import { VendorChangeRequests as VendorChangeRequestsComponent } from '../../../components/ChangeRequest';

export function VendorChangeRequests() {
  return <VendorChangeRequestsComponent />;
}
